import store from 'utils/store/withMiddleware'

export default function setAgreement(): void {
  const state = store.getState()
  const { sDate, planId } = state

  if (!sDate) {
    return
  }

  state.hcStorage.delayedEffectiveDateAgreement = `${planId}-${sDate}`
  store.update(state)
}
